export const COMMON_EMAIL_DOMAINS: string[] = [
  // Google
  'gmail.com', 'googlemail.com', 'gmail.co.uk', 'gmail.es', 'gmail.fr', 'gmail.de', 'gmail.it', 'gmail.com.br',

  // Microsoft / Outlook
  'outlook.com', 'outlook.es', 'outlook.fr', 'outlook.de', 'outlook.co.uk',
  'hotmail.com', 'hotmail.es', 'hotmail.fr', 'hotmail.de', 'hotmail.co.uk',
  'live.com', 'live.es', 'live.fr', 'live.de', 'live.co.uk',
  'msn.com', 'msn.es', 'msn.fr', 'msn.de',

  // Yahoo
  'yahoo.com', 'yahoo.es', 'yahoo.fr', 'yahoo.de', 'yahoo.co.uk',
  'ymail.com', 'rocketmail.com',

  // Apple
  'icloud.com', 'me.com', 'mac.com',

  // ProtonMail
  'protonmail.com', 'protonmail.ch', 'protonmail.de',

  // Zoho
  'zoho.com', 'zoho.eu', 'zoho.in',

  // GMX
  'gmx.com', 'gmx.es', 'gmx.de', 'gmx.fr',

  // AOL
  'aol.com', 'aim.com',

  // Yandex / Mail.ru
  'yandex.com', 'yandex.ru', 'mail.ru', 'bk.ru', 'list.ru', 'inbox.ru',

  // FastMail / Hushmail / Tutanota
  'fastmail.com', 'hushmail.com', 'tutanota.com', 'mail.com', 'me.com',

  // ISP y proveedores regionales
  'comcast.net', 'btinternet.com', 'shaw.ca', 'rogers.com', 'att.net', 'verizon.net',
  'bellsouth.net', 'cox.net', 'earthlink.net', 'charter.net',

  // Educación y trabajo
  'edu', 'ac.uk', 'univ.es', 'student.univ.fr', 'company.com', 'business.org',

  // Internacionales populares
  'hotmail.it', 'hotmail.nl', 'hotmail.be', 'hotmail.ch', 'gmail.nl', 'gmail.be', 'gmail.ch',
  'yahoo.it', 'yahoo.nl', 'yahoo.be', 'yahoo.ch', 'outlook.it', 'outlook.nl', 'outlook.be', 'outlook.ch',

];
